import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import {
  Rarity,
  So5LeaderboardSeasonality,
} from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineXS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import { scarcityNames } from '@sorare/core/src/lib/cards';

import { seasonalityMessages } from 'lib/so5';

const Root = styled(Horizontal)`
  width: 100%;
`;

export const CompetitionTitle = styled(HeadlineXS)`
  width: 100%;
  padding-bottom: var(--half-unit);
  border-bottom: 1px solid var(--c-nd-200);
`;

type Props = {
  rarity: Nullable<Rarity>;
  seasonality: Nullable<So5LeaderboardSeasonality>;
  count: number;
};

export const CompetitionHeader = ({ rarity, seasonality, count }: Props) => {
  return (
    <Root>
      <CompetitionTitle color="var(--c-nd-600)">
        {rarity && scarcityNames[rarity]}
        {seasonality && (
          <>
            {' '}
            • <FormattedMessage {...seasonalityMessages[seasonality]} />
          </>
        )}{' '}
        <Chip>{count}</Chip>
      </CompetitionTitle>
    </Root>
  );
};
